import React from "react";
import {useDispatch} from "react-redux";

import styles from "../../sidePanel/constructionCalculationsPanel.module.scss";
import tabStyles from "./mastTab.module.scss";

import {switchMast} from "../../../constructionCalculationsNewSlice";
import type IMastTab from "../types/IMastTab";

const MastTab: React.FunctionComponent<{
  tab: IMastTab;
  selectedMastNo: string | undefined;
}> = ({tab, selectedMastNo}) => {
  const dispatch = useDispatch();

  return (
    <div
      key={`${tab.number}`}
      className={
        selectedMastNo !== undefined && tab.number === selectedMastNo
          ? `${styles.mastBtn} ${styles.selected}`
          : styles.mastBtn
      }
      onClick={() => {
        void dispatch(switchMast(tab.number));
      }}>
      <span className={tab.profileIsValid ? styles.valid : styles.notValid}>
        {tab.number}
      </span>
      <span className={tab.profileIsValid ? styles.valid : styles.notValid}>
        {tab.type}
      </span>
      <span className={tabStyles.foundationType}>{tab.foundation}</span>
    </div>
  );
};

export default MastTab;